import script from "./TestRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./TestRecord.vue?vue&type=script&setup=true&lang=js"

import "./TestRecord.vue?vue&type=style&index=0&id=6e25171d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e25171d"]])

export default __exports__